import { CustomTooltip } from '@/shared/ui/components';
import { Typography } from 'antd';
import classNames from 'classnames';
import { useTooltipFormatter } from './useTooltipFormatter';
import type { TooltipFormatterProps } from './tooltipFormatter.types';

const { Paragraph } = Typography;

/**
 * Renders text clamped to a fixed number of rows with the full value available in a tooltip. Attaches the tooltip title and pointer cursor only when the paragraph's ellipsis actually fires, tracked by useTooltipFormatter.
 *
 * @param text - Text to display and to show in full inside the tooltip.
 * @param rows - Number of rows to show before truncating, defaulting to two.
 * @param tooltipClassName - Extra class merged into the tooltip root.
 * @returns The tooltip-wrapped clamped paragraph.
 */
const TooltipFormatter = ({ text = '', rows = 2, tooltipClassName }: TooltipFormatterProps) => {
  const { truncated, setTruncated } = useTooltipFormatter();

  return (
    <CustomTooltip
      title={truncated ? text : undefined}
      classNames={{ root: classNames('tooltip-card', tooltipClassName) }}
      placement="bottomLeft"
      mouseLeaveDelay={0}
      mouseEnterDelay={0}
    >
      <Paragraph
        className="tooltip-text"
        style={
          truncated
            ? {
                marginBottom: 0,
                cursor: 'pointer',
              }
            : {
                marginBottom: 0,
              }
        }
        ellipsis={{
          rows,
          expandable: false,
          onEllipsis: setTruncated,
        }}
      >
        {text}
      </Paragraph>
    </CustomTooltip>
  );
};

export default TooltipFormatter;
